import PropTypes from 'prop-types';

export default {
  handleClose: PropTypes.func,
  editOpened: PropTypes.bool,
  centered: PropTypes.bool,
  showDate: PropTypes.bool,
  selectedRoute: PropTypes.object,
  routes: PropTypes.arrayOf(PropTypes.object),
  selectedTrip: PropTypes.object,
  toggleRoutes: PropTypes.func,
  classes: PropTypes.object,
  selectedPassenger: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
};



// WEBPACK FOOTER //
// ./src/containers/seats/mobile/SeatSelectionDialogProps.js